import JSONModel from "sap/ui/model/json/JSONModel";

class ModelManager {
    private static instance: ModelManager;
    private dataModel: JSONModel;
    private authModel: JSONModel;

    private constructor() {

        const currentYear = new Date().getFullYear();
        const startOfYear = new Date(currentYear, 0, 1); // 0 = Januar, 1 = erster Tag

        this.dataModel = new JSONModel({
            busy: false,
            currentYear: currentYear,
            startOfYear: startOfYear.toISOString().split("T")[0],
        });

        this.authModel = new JSONModel({
            authenticated: false,
            isUser: false,
            isTeamLead: false,
            isDepartmentManager: false,
            isProjectManager: false,
            isAdmin: false,

        });
    }

    public static getInstance(): ModelManager {
        if (!ModelManager.instance) {
            ModelManager.instance = new ModelManager();
        }
        return ModelManager.instance;
    }


    public getDataModel(): JSONModel {
        return this.dataModel;
    }

    public getAuthModel(): JSONModel {
        return this.authModel;
    }
}

export default ModelManager;